import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import Parameters from "./Parameters.graphql";
import { taxonomy } from "../../api";

export default function useParameters() {
    return useQuery(
        gql(Parameters),
        {
            client: taxonomy,
        },
    );
}
